(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('FeedBack', FeedBack);

    FeedBack.$inject = ['$resource', 'DateUtils'];

    function FeedBack($resource, DateUtils) {
        var resourceUrl = 'api/feedbacks/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertDateTimeFromServer(data.criadoEm);
                    }
                    return data;
                }
            },
            'getUltimo': {
                method: 'GET',
                url: 'api/feedbacks/ultimo',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertDateTimeFromServer(data.criadoEm);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
